<template>
	<div>
		<div class="control-item">
			<button v-on:click="selectAll">全部选中</button>
		</div>
		<div class="control-item">
			<button v-on:click="eligible" type="">好品(G)</button>
		</div>
		<div class="control-item">
			<button v-on:click="ineligible">坏品(B)</button>
		</div>

		<div class="control-item">
			<label for>缺陷类型：</label>
			<select v-model="type">
				<option :value="-1">全部</option>
				<option v-for="item in defectTypes" v-bind:key="item.value" :value="item.value" :label="item.label"></option>
			</select>
		</div>
		<div class="control-item">
			<label for>缺陷状态：</label>
			<select v-model="status">
				<option v-for="item in statelist" v-bind:key="item.value" :value="item.value" :label="item.text"></option>
			</select>
		</div>
		<div class="control-item">
			<label for>检测面：</label>
			<select v-model="surface">
				<option v-for="item in surfacelist" v-bind:key="item.value" :value="item.value" :label="item.text"></option>
			</select>
		</div>
		<div class="control-item">
			<p>
				<label for="">好品1：<span v-text="goodCount"></span></label>
			</p>
			<p>
				<label for="">坏品1：<span v-text="badCount">0</span></label>
			</p>
		</div>

		<div class="control-item">
			<button disabled="true" v-on:click="changeFilterStatus" type="button" v-text="filterStatusText"></button>
		</div>

		<div class="control-item">
			<a href="#" @click="dialogVisible = true" style="color:#aaa;">快捷键提示</a>
		</div>
		<div class="remark_box">
			<label for="browser_show_remark">
				<input id="browser_show_remark" type="checkbox" v-model="checkedValue" @change="changeValue" />
				查标记码
			</label>
			<textarea placeholder="请输入查询内容" style="width:112px; margin-top:5px;" rows="10"> </textarea>
		</div>

		<!-- <el-row style="margin-top: 20px;border-top: 1px #cacaca solid;padding-top: 20px;">
			<el-col :span="12">
				<div class="form">
					<div class="form-item"><input type="text" placeholder="输入批次号" /> <button @click="searchBatch">搜索</button></div>
					<div class="form-item"><input type="text" placeholder="输入质量追溯码" /> <button @click="searchDefect">搜索</button></div>
				</div>
			</el-col>
			<el-col :span="12"> </el-col>
		</el-row> -->

		<el-dialog title="快捷键提示" :visible.sync="dialogVisible" width="350px">
			<div class="shortcut">
				<ul>
					<li>
						<label for="">向下移动快捷键：</label>
						<span>↓</span>
					</li>
					<li>
						<label for="">向上移动快捷键：</label>
						<span>↑</span>
					</li>
					<li>
						<label for="">好品：</label>
						<span>G</span>
					</li>
					<li>
						<label for="">坏品：</label>
						<span>B</span>
					</li>
				</ul>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		
	</div>
</template>

<script>
	import defectService from '@/service/defectService'
	export default {
		props: {
			defectTypes: {
				type: Array,
				required: true,
			},
			goodCount: {
				type: Number,
			},
			badCount: {
				type: Number,
			},
			modelSides: {
				type: Array,
			},
			batchInfo: {
				type: Object,
			},
		},
		data() {
			return {
				textarea: '',
				type: -1,
				status: '',
				surface: 0,
				checked: false,
				dialogVisible: false,
				checkedValue: false,
				// surfacelist: [
				// 	{
				// 		value: 0,
				// 		text: '全部',
				// 	},
				// 	{
				// 		value: 1,
				// 		text: '正面',
				// 	},
				// 	{
				// 		value: 2,
				// 		text: '反面',
				// 	},
				// 	{
				// 		value: 3,
				// 		text: '3D面',
				// 	},
				// ],
				statelist: [
					{
						value: '',
						text: '全部',
					},
					{
						value: 'good',
						text: '好品',
					},
					{
						value: 'bad',
						text: '坏品',
					},
				],
			}
		},
		computed: {
			surfacelist() {
				var list = []
				if (this.modelSides) {
					this.modelSides.forEach((v, i) => {
						console.log('modelsides', v)
						list.push({
							value: v.side_index,
							text: v.name,
						})
					})
				}
				return list.sort((a, b) => {
					return a.value - b.value
				})
			},
			filterStatusText() {
				if (this.batchInfo) {
					var status = this.batchInfo.filter_status ?? 0

					if (status == 0) {
						return '未筛选'
					} else if (status == 1) {
						//进行时间的插入filter_time
						return '正在筛选'
					}

					return defectService.getFilterStatusText(this.batchInfo.filter_status)
				}

				return 'loading'
			},
		},
		watch: {
			type(val) {
				this.$emit('changeType', val)
			},
			status(val) {
				this.$emit('changeStatus', val)
			},
			surfacelist(val) {
				if (val.length > 0) {
					if (val.length > 0) {
						this.surface = val[0].value
					}
				}
			},
			surface(val) {
				console.log('change surface', val)
				this.$emit('changeSurface', val)
			},
		},
		methods: {
			changeValue() {
				alert('通过选中自动搜索标记内容')
			},
			selectAll() {
				this.checked = !this.checked
				this.$emit('selectAll', this.checked)
			},
			eligible() {
				this.$emit('eligible')
			},
			ineligible() {
				this.$emit('ineligible')
			},
			onKeyDown(e) {
				console.log('key down', e)
				const key = window.event.keyCode
				if (key == 71) {
					console.log('好品')
					e.preventDefault()
				} else if (key == 65) {
					console.log('坏品')
					e.preventDefault()
				}
			},
			changeFilterStatus() {
				if (this.batchInfo) {
					var current_status = this.batchInfo.filter_status ?? 0
					var status = current_status
					if (current_status == 1) {
						status = 2
					}
					this.$emit('changeFilterStatus', status)
				}
			},
		},
		mounted() {
			document.addEventListener('onkeydown', this.onkeydown)
		},
		destroyed() {
			document.removeEventListener('onkeydown', this.onkeydown)
		},
	}
</script>

<style scoped>
	.control-item {
		margin-bottom: 5px;
	}

	.control-item button {
		width: 100%;
	}

	.control-item label,
	label {
		display: block;
		color: #000;
	}

	.control-item select {
		width: 100%;
		padding: 5px;
	}

	/* .shortcut {
	} */

	.shortcut ul {
		margin: 0;
		padding: 0;
	}

	.shortcut li {
		list-style: none;
		font-size: 12px;
		color: #aaa;
		padding: 5px 0;
	}

	.shortcut li label {
		display: inline-block;
		width: 130px;
		text-align: right;
	}

	.outer {
		height: 100%;
		margin: 0;
		padding: 0;
	}

	.shortcut li span {
		background-color: #aaa;
		display: inline-block;
		width: 24px;
		height: 24px;
		color: #fff;
		text-align: center;
		border-radius: 3px;
		line-height: 24px;
	}

	.remark_box {
		position: absolute;
		left: 0;
		right: 0;
		bottom: 10px;
	}
</style>
